// Version : 0.0.2
// Author : VISHAL BHARATHI
// LastEdit : VISHAL BHARATHI
// Last ADD : TERNARY OPERATORS REMOVED
// MODFIED DATA : 07-08-2025

import { takeLatest, put, all, call } from 'redux-saga/effects';

import CenterActionTypes from './center.types';
import {
	centerDetailsAdd,
	centerDetailsUpdate,
	centerListGet,
	centerDetailsFetch,
	centerDetailsDelete,
} from './center.service';

import {
	// ADD CENTER
	addCenterDetailsSuccess,
	addCenterDetailsFailure,
	addCenterDetailsResponseChanged,
	// UPDATE CENTER
	updateCenterDetailsSuccess,
	updateCenterDetailsFailure,
	updateCenterDetailsResponseChanged,
	// GET CENTER LIST
	getCenterListSuccess,
	getCenterListFailure,
	getCenterListResponseChanged,
	// FETCH CENTER DETAILS
	fetchCenterDetailsSuccess,
	fetchCenterDetailsFailure,
	fetchCenterDetailsResponseChanged,
	// DELETE CENTER
	deleteCenterDetailsSuccess,
	deleteCenterDetailsFailure,
	deleteCenterDetailsResponseChanged,
} from './center.action';
import { encryptData } from '../../_common/enode-decode';

import AlertManager from '../../../utils/alertManager';
/** *********************  START ADD CENTER DETAILS  ******************** */
export function* createCenter({ payload }: any) {
	try {
		const key = 'AddCenterDetailsKey';
		const {
			branchID,
			databaseName,
			nextUniqueCenterID,
			centerName,
			centerAddress,
			centerPincode,
			centerPhoneNumber,
			centerLankMark,
			centerMeetUpLocation,
			centerMapLatitude,
			centerMapLongitude,
			centerBranchDistance,
			userName,
			companyID,
			userAccessBranchID,
			companyModal,
			centerMeetingDay,
			centerMeetingFrequency,
			centerMeetUpTime,
			centerNextMeetingDate,
			centerStartDate,
			village,
			isIndividualCenter,
			isWeeklyCenter,
			isDefaultNoLoan,
			isGoldLoanCenter,
			whichWeek,
			userID,
		} = payload;
		const jsonData = {
			BranchID: branchID,
			DatabaseName: databaseName,
			UniqueBranchID: nextUniqueCenterID,
			CenterName: centerName,
			LocationAddress: centerAddress,
			LocationPinCode: centerPincode,
			PhoneNumber: centerPhoneNumber,
			Landmark: centerLankMark,
			MeetUpLocation: centerMeetUpLocation,
			Latitude: centerMapLatitude,
			Longitude: centerMapLongitude,
			DistanceFromBranch: centerBranchDistance,
			UserName: userName,
			CompanyID: companyID,
			UserAccessBranchID: userAccessBranchID,
			companyModal: companyModal,
			Meetingday: centerMeetingDay,
			Meetingfrequency: centerMeetingFrequency,
			MeetUpTime: centerMeetUpTime,
			Nextmeetingdate: centerNextMeetingDate,
			Centerstartdate: centerStartDate,
			Village: village,
			ForPersonalLoanCenter: isIndividualCenter,
			IsWeekDayBasedCenter: isWeeklyCenter,
			IsDefaultCenter: isDefaultNoLoan,
			IsGoldLoanCenter: isGoldLoanCenter,
			WhichWeek: whichWeek,
			CreatedBy: userID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(centerDetailsAdd, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addCenterDetailsFailure(responseData.data));
		} else {
			yield put(addCenterDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addCenterDetailsFailure(error));
	}
}

export function* resetAddCenterResponse() {
	yield put(addCenterDetailsResponseChanged());
}

export function* onCreateCenterDetails() {
	yield takeLatest(CenterActionTypes.ADD_CENTER_DETAILS_START, createCenter);
}

export function* onCreateCenterResponseReset() {
	yield takeLatest(CenterActionTypes.ADD_CENTER_DETAILS_RESPONSE_RESET, resetAddCenterResponse);
}
/** *********************  END ADD CENTER DETAILS ******************** */

/** *********************  START UPDATE CENTER DETAILS  ******************** */
export function* centerUpdate({ payload }: any) {
	try {
		const key = 'UpdateCenterDetailsKey';
		const {
			centerID,
			branchID,
			databaseName,
			nextUniqueCenterID,
			centerName,
			centerAddress,
			centerPincode,
			centerPhoneNumber,
			centerLankMark,
			centerMeetUpLocation,
			centerMapLatitude,
			centerMapLongitude,
			centerBranchDistance,
			userName,
			companyID,
			userAccessBranchID,
			companyModal,
			centerMeetingDay,
			centerMeetingFrequency,
			centerMeetUpTime,
			centerNextMeetingDate,
			centerStartDate,
			village,
			isIndividualCenter,
			isWeeklyCenter,
			isDefaultNoLoan,
			isGoldLoanCenter,
			whichWeek,
			userID,
			SHGGroupID,
		} = payload;
		const jsonData = {
			CenterID: centerID,
			BranchID: branchID,
			DatabaseName: databaseName,
			UniqueBranchID: nextUniqueCenterID,
			LocationName: centerName,
			LocationAddress: centerAddress,
			LocationPinCode: centerPincode,
			PhoneNumber: centerPhoneNumber,
			Landmark: centerLankMark,
			MeetUpLocation: centerMeetUpLocation,
			Latitude: centerMapLatitude,
			Longitude: centerMapLongitude,
			DistanceFromBranch: centerBranchDistance,
			Meetingday: centerMeetingDay,
			Meetingfrequency: centerMeetingFrequency,
			MeetUpTime: centerMeetUpTime,
			Nextmeetingdate: centerNextMeetingDate,
			Centerstartdate: centerStartDate,
			Village: village,
			CenterName: centerName,
			ForPersonalLoanCenter: isIndividualCenter,
			IsWeekDayBasedCenter: isWeeklyCenter,
			IsDefaultCenter: isDefaultNoLoan,
			IsGoldLoanCenter: isGoldLoanCenter,
			WhichWeek: whichWeek,
			CreatedBy: userID,
			UserName: userName,
			CompanyID: companyID,
			UserAccessBranchID: userAccessBranchID,
			companyModal: companyModal,
			SHGGroupID: SHGGroupID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(centerDetailsUpdate, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateCenterDetailsFailure(responseData.data));
		} else {
			yield put(updateCenterDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateCenterDetailsFailure(error));
	}
}

export function* resetUpdateCenterDetailsResponse() {
	yield put(updateCenterDetailsResponseChanged());
}

export function* onUpdateCenterDetails() {
	yield takeLatest(CenterActionTypes.UPDATE_CENTER_DETAILS_START, centerUpdate);
}

export function* onUpdateCenterResponseReset() {
	yield takeLatest(
		CenterActionTypes.UPDATE_CENTER_DETAILS_RESPONSE_RESET,
		resetUpdateCenterDetailsResponse,
	);
}
/** *********************  END UPDATE CENTER DETAILS ******************** */

/** *********************  START GET CENTER LIST  ******************** */
export function* centerDetailsListGet({ payload }: any) {
	try {
		const key = 'GetCenterListKey';
		const {
			databaseName,
			companyID,
			userAccessBranchID,
			userID,
			userRole,
			userLevel,
			inputSearch,
			limit,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			UserID: userID,
			UserRole: userRole,
			UserLevel: userLevel,
			DatabaseName: databaseName,
			BranchID: userAccessBranchID,
			InputSearch: inputSearch,
			Limit: limit,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(centerListGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getCenterListFailure(responseData.data));
		} else {
			yield put(getCenterListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getCenterListFailure(error));
	}
}

export function* resetGetCenterListResponse() {
	yield put(getCenterListResponseChanged());
}

export function* onGetCenterListDetails() {
	yield takeLatest(CenterActionTypes.GET_CENTER_LIST_START, centerDetailsListGet);
}

export function* onGetCenterListResponseReset() {
	yield takeLatest(CenterActionTypes.GET_CENTER_LIST_RESPONSE_RESET, resetGetCenterListResponse);
}
/** *********************  END GET CENTER LIST ******************** */

/** *********************  START FETCH CENTER DETAILS  ******************** */
export function* fetchCenterData({ payload }: any) {
	try {
		const key = 'FetchCenterDetailsKey';
		const { centerID, databaseName, companyID } = payload;
		const jsonData = {
			CompanyID: companyID,
			CenterID: centerID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(centerDetailsFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchCenterDetailsFailure(responseData.data));
		} else {
			yield put(fetchCenterDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchCenterDetailsFailure(error));
	}
}

export function* resetFetchCenterDetailsResponse() {
	yield put(fetchCenterDetailsResponseChanged());
}

export function* onFetchCenterDetails() {
	yield takeLatest(CenterActionTypes.FETCH_CENTER_DETAILS_START, fetchCenterData);
}

export function* onFetchCenterResponseReset() {
	yield takeLatest(
		CenterActionTypes.FETCH_CENTER_DETAILS_RESPONSE_RESET,
		resetFetchCenterDetailsResponse,
	);
}
/** *********************  END FETCH CENTER DETAILS ******************** */

/** *********************  START DELETE CENTER DETAILS  ******************** */
export function* centerDelete({ payload }: any) {
	try {
		const key = 'DeleteCenterDetailsKey';
		const {
			centerID,
			databaseName,
			locationName,
			userName,
			companyID,
			userAccessBranchID,
			userID,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			CenterID: centerID,
			LocationName: locationName,
			DatabaseName: databaseName,
			DeletedBy: userID,
			UserAccessBranchID: userAccessBranchID,
			UserName: userName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(centerDetailsDelete, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(deleteCenterDetailsFailure(responseData.data));
		} else {
			yield put(deleteCenterDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(deleteCenterDetailsFailure(error));
	}
}

export function* resetDeleteCenterDetailsResponse() {
	yield put(deleteCenterDetailsResponseChanged());
}

export function* onDeleteCenterDetail() {
	yield takeLatest(CenterActionTypes.DELETE_CENTER_DETAILS_START, centerDelete);
}

export function* onDeleteCenterResponseReset() {
	yield takeLatest(
		CenterActionTypes.DELETE_CENTER_DETAILS_RESPONSE_RESET,
		resetDeleteCenterDetailsResponse,
	);
}
/** *********************  END DELETE CENTER DETAILS ******************** */

export function* centerMasterSaga() {
	yield all([
		call(onCreateCenterDetails),
		call(onCreateCenterResponseReset),
		call(onUpdateCenterDetails),
		call(onUpdateCenterResponseReset),
		call(onGetCenterListDetails),
		call(onGetCenterListResponseReset),
		call(onFetchCenterDetails),
		call(onFetchCenterResponseReset),
		call(onDeleteCenterDetail),
		call(onDeleteCenterResponseReset),
	]);
}
